module.exports = __webpack_public_path__ + "d52db1acc3c9bf74d710a868b3651101.svg";